import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { QrCode } from '../components/QrCode.js';
import { usePaymentState } from '../../../hooks/use-payment-state.js';
import { useQrPaymentState } from '../../../hooks/use-qr-payment-state.js';

const QrCodeContainer = ({ paymentMethodType , logoSettings , orderId , paymentResponse , paymentFlow , orderToken , onQrCodeRefresh , refetch , cart  })=>{
    const { getLabel  } = useIntl();
    const [paymentState, error] = usePaymentState(orderId);
    const { className , externalUrl , isOpen , isQrCodeExpired , isQrRefreshLoading , onCancel , qrCodeUrl ='' , refreshQrCode ,  } = useQrPaymentState({
        orderId,
        paymentState,
        error,
        paymentResponse,
        paymentFlow,
        orderToken,
        onQrCodeRefresh,
        cart,
        refetch
    });
    const labels = React.useMemo(()=>({
            cancel: getLabel(`checkout.payment.method.${paymentMethodType}.qr.action.cancel`),
            title: getLabel(`checkout.payment.method.${paymentMethodType}.qr.title`),
            refresh: getLabel(`checkout.payment.method.${paymentMethodType}.qr.action.refresh`),
            link: getLabel(`checkout.payment.method.${paymentMethodType}.qr.action.link`),
            description: getLabel(`checkout.payment.method.${paymentMethodType}.qr.description`)
        })
    , [
        getLabel,
        paymentMethodType
    ]);
    return /*#__PURE__*/ React.createElement(QrCode, {
        className: className,
        externalUrl: externalUrl,
        isOpen: isOpen,
        isQrCodeExpired: isQrCodeExpired,
        isQrRefreshLoading: isQrRefreshLoading,
        labels: labels,
        logoSettings: logoSettings,
        onCancel: onCancel,
        qrCodeUrl: qrCodeUrl,
        refreshQrCode: refreshQrCode
    });
};

export { QrCodeContainer };
//# sourceMappingURL=QrCodeContainer.js.map
